import { PersonalCard } from '../components/PersonalCard';

export function ProfileSection() {
  return <PersonalCard />;
}
